import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import useCommonStyles from 'styles/common';

import r01Img from 'assets/invoice/product/r-01.png'
import w01Img from 'assets/invoice/product/w-01.png'
import w02Img from 'assets/invoice/product/w-02.png'
import v01Img from 'assets/invoice/product/v-01.png'
import f01Img from 'assets/invoice/product/f-01.png'
import g01Img from 'assets/invoice/product/g-01.png'
import CenterImage from 'components/common/CenterImage';
import { Cauli, Tomato03 } from '../stamps';

const useStyles = makeStyles((theme) => ({
	products: {
		padding: 20,
		flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
			paddingTop: 10,
        	paddingBottom: 16
		}
	},
	productsTitle: {
		borderRadius: 16,
		padding: 15,
		maxWidth: 880,
		marginBottom: 24,
		position: 'relative',
        [theme.breakpoints.down('xs')]: {
			marginBottom: 8,
			'& p': { fontSize: 24 }
		}
	},
	targetProductsTitle: {
		backgroundColor: 'var(--color-primary)',
	},
	pairedProductsTitle: {
		backgroundColor: 'var(--color-tertiary)',
	},
	productCardsContainer: {
		maxWidth: 880,
		display: 'flex',
		flexWrap: 'nowrap',
		gap: 16,
		marginBottom: 36,
        [theme.breakpoints.down('xs')]: {
			marginBottom: 8,
			gap: 8
		}
	},
	productCardsContainerDisplayInMobile: {
		display: 'none',
        [theme.breakpoints.down('xs')]: {
			display: 'flex'
		}
	},
	productCard: {
		backgroundColor: 'var(--color-white)',
		borderRadius: 16,
		border: '1px solid',
    	display: 'flex',
    	flexDirection: 'column',
    	alignItems: 'center',
		flex: '1 1 150px',
		aspectRatio: '1/1',
		boxSizing: 'border-box',
    	gap: 36,

		paddingBottom: 31,
		justifyContent: 'end',

        [theme.breakpoints.down('xs')]: {
			gap: 'unset',
			paddingBottom: 10
		}
	},
	productCardSlim: {
        [theme.breakpoints.down('xs')]: {
			'& > div': {
				padding: '0 24px',
				paddingTop: 5,
				flex: 1
			}
		}
	},
	productCardWide: {
		flex: '2 1 300px',
		aspectRatio: '2/1', // seems not work
        [theme.breakpoints.down('xs')]: {
			flex: '1 1 150px',
		}
	},
	productCardImage: {
		width: 200,
		paddingTop: 22,
        [theme.breakpoints.down('xs')]: {
			width: 'auto',
			paddingTop: 0,
		}
	},
	productCardWideImageSection: {
		gap: 13,
        [theme.breakpoints.down('xs')]: {
			gap: 5,
			flexDirection: 'column',
			padding: '0 35px',
			flex: 1
		}
	},
	tripplePairedProductCard: {
		gap: '10%'
	},
	trippleProductCardImage: {
		padding: '0 10px'
	},

	targetProductCard: {
		borderColor: 'var(--color-primary)',
	},
	pairedProductCard: {
		borderColor: 'var(--color-tertiary)',
	},
}));

const Products: FC = () => {
	const classes = useStyles();
	const common = useCommonStyles();

	return (<div className={ cx(common.center, common.fullWidth, classes.products) }>
		<div className={ cx(classes.productsTitle, classes.targetProductsTitle, common.fullWidth) }>
			<Typography variant='body1' style={{ color: 'var(--color-white)' }}>
				{`指定購買商品任一盒`}
			</Typography>
		</div>

		<div className={ cx(classes.productCardsContainer, common.fullWidth) }>
			<div className={ cx(classes.productCard, classes.targetProductCard, classes.productCardSlim)}>
				<CenterImage src={r01Img} className={classes.productCardImage}/>
				<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
					{`House好侍
					蕃茄燴飯料理塊`}
				</Typography>
			</div>
			<div className={ cx(classes.productCard, classes.targetProductCard, classes.productCardWide) }>
				<div className={cx(common.center, classes.productCardWideImageSection)}>
					<CenterImage src={w01Img} className={classes.productCardImage}/>
					<CenterImage src={w02Img} className={classes.productCardImage}/>
				</div>
				<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
					{`House好侍
					北海道白醬料理塊全系列`}
				</Typography>

			</div>
		</div>

		<div className={ cx(classes.productsTitle, classes.pairedProductsTitle, common.fullWidth) }>
			<Typography variant='body1' style={{ color: 'var(--color-white)' }}>
				{`任選搭配商品`}
			</Typography>
			<Tomato03 className={common.displayInMobile} style={{ top: 373, right: 30, width: 30, transform: 'rotate(-27deg)'}} />
			<Cauli  className={common.displayInMobile} style={{ top: 300, right: -8, width: 38, transform: 'rotate(41deg)'}} />

		</div>

		<div className={ cx(classes.productCardsContainer, common.fullWidth) }>
			<div className={ cx(classes.productCard, classes.pairedProductCard, classes.tripplePairedProductCard) }>
				<CenterImage src={f01Img} className={classes.trippleProductCardImage}/>
				<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
					{`House好侍
					佛蒙特咖哩全系列`}
				</Typography>
			</div>
			<div className={ cx(classes.productCard, classes.pairedProductCard, classes.tripplePairedProductCard) }>
				<CenterImage src={g01Img} className={classes.trippleProductCardImage}/>
				<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
					{`House好侍
					爪哇咖哩全系列`}
				</Typography>
			</div>
			<div className={ cx(classes.productCard, classes.pairedProductCard, classes.productCardSlim, common.hideInMobile) }>
				<CenterImage src={v01Img} className={classes.productCardImage}/>
				<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
					{`House好侍
					素食咖哩塊`}
				</Typography>
			</div>
		</div>
		<div className={ cx(classes.productCardsContainer, common.fullWidth, classes.productCardsContainerDisplayInMobile) }>
			<div className={ cx(classes.productCard, classes.pairedProductCard, classes.productCardSlim) }>
				<CenterImage src={v01Img} className={classes.productCardImage}/>
				<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
					{`House好侍
					素食咖哩塊`}
				</Typography>
			</div>
			<div className={ cx(classes.productCard, classes.pairedProductCard, common.invisible) }>
			</div>
		</div>
	</div>);
};

export default Products;
